module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pageContent"
  }, [_c('pageTitle', {
    attrs: {
      "title": "我的收藏"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "0.2rem"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.IsLoading),
      expression: "  IsLoading  "
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "align": "center"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "1.2rem",
      "margin": "2.1rem auto 0 auto"
    },
    attrs: {
      "src": require("../../../static/LoadingGrey.gif")
    }
  })]), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.IsLoading),
        expression: "  !IsLoading  "
      }],
      staticStyle: {
        "background-color": "white"
      },
      attrs: {
        "align": "center"
      }
    }, [_c('table', {
      staticStyle: {
        "width": "92%",
        "text-align": "left"
      },
      attrs: {
        "border": "0"
      }
    }, [_c('tr', [_c('td', {
      staticStyle: {
        "width": "1.2rem"
      },
      attrs: {
        "rowspan": "4"
      },
      on: {
        "click": function($event) {
          return _vm.gohotel(item.HotelCode)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "width": "1rem",
        "margin": "0 0 0 0rem"
      },
      attrs: {
        "src": item.Logo != '' ? item.Logo : '../../../static/search/noImg.jpg'
      }
    })]), _vm._v(" "), _c('td', {
      staticStyle: {
        "color": "#666666",
        "font-weight": "bold"
      },
      on: {
        "click": function($event) {
          return _vm.gohotel(item.HotelCode)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "margin-top": "1vh"
      }
    }, [_vm._v("\n            " + _vm._s(item.HotelName) + "\n          ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "15%"
      },
      attrs: {
        "align": "center",
        "rowspan": "2"
      }
    }, [_c('div', {
      staticStyle: {
        "border": "1px solid #DCDCDC",
        "padding": "0.1rem"
      },
      on: {
        "click": function($event) {
          return _vm.deleteitem(item.HotelCode)
        }
      }
    }, [_c('div', {
      staticStyle: {
        "font-size": "0.22rem"
      }
    }, [_vm._v("\n              删除\n            ")])])])]), _vm._v(" "), _c('tr', [_c('td', {}, [_c('div', {
      staticStyle: {
        "margin-bottom": "1vh"
      }
    }, [_c('img', {
      staticStyle: {
        "height": "11px"
      },
      attrs: {
        "src": require("../../../static/order/position.png")
      }
    }), _vm._v(" "), _vm._v("\n            " + _vm._s(item.Address) + "\n          ")])])])]), _vm._v(" "), _c('mu-divider')], 1)
  }), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "mainTitle": "暂无收藏，添加收藏下次查找更方便哦！",
      "mainIcon": "noCollect",
      "extendBtn": true,
      "noMore": true,
      "isLoading": _vm.IsLoading,
      "overZero": _vm.list.length > 0
    },
    on: {
      "btnHandler": _vm.goHome
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": ""
    },
    on: {
      "close": _vm.closeNO
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#666666",
      "margin-bottom": "1.5vh"
    }
  }, [_vm._v("\n      您真的要删除这条收藏吗？\n    ")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flat-button', {
    staticStyle: {
      "background-color": "#cccccc",
      "color": "white"
    },
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": _vm.closeNO
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flat-button', {
    staticStyle: {
      "background-color": "#27BA69",
      "color": "white"
    },
    attrs: {
      "slot": "actions",
      "label": "确定"
    },
    on: {
      "click": _vm.closeYES
    },
    slot: "actions"
  })], 1)])])]), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "message": _vm.TellUser,
      "id": "alertline"
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1728a40a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/MyCollection.vue
// module id = 1433
// module chunks = 18